import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import TagIcon from '../components/TagIcon'

const Post = styled.li`
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 15px;
  overflow: hidden;
  margin: 0 0 1em 0;
  width: 100%;
  transition: 0.3s;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 49%')};
    margin: 0 0 2vw 0;
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 32%')};
  }
  &:hover {
  }
  a {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    color: ${props => props.theme.colors.base};
    text-decoration: none;
    .gatsby-image-wrapper {
      height: 0;
      padding-bottom: 60%;
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        padding-bottom: ${props => (props.featured ? '40%' : '60%')};
      }
    }
    img {
      border-radius: 7px 7px 3px 3px;
    }
  }
`

const Title = styled.h2`
  font-size: 1.4em;
  font-weight: 600;
  margin: 0.7rem 0.02rem;
  line-height: 1.4;
`

const Date = styled.h3`
  margin: 1rem 0.02rem 0;
  color: #babebf;
  font-weight: 200;
  font-size: 14px;
`

const MetaBlock = styled.div`
  display: inline-block;
`

const NewMark = styled.div`
  padding: 0.8em 1em 0.7em;
  letter-spacing: 0.05em;
  background: ${props => props.theme.colors.highlight};
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 12px 2px 12px 2px;
  display: ${props => (props.featured ? 'block' : 'none')};
`

const Card = ({ slug, heroImage, title, publishDate, tags, ...props }) => {
  return (
    <Post featured={props.featured}>
      <Link to={`/${slug}/`}>
        <Img fluid={heroImage.fluid} backgroundColor={'#eeeeee'} />
        <Date className="webfont">{publishDate}</Date>
        <Title>{title}</Title>
        <MetaBlock>
          {tags &&
            tags.map(tag => <TagIcon key={`tag-${tag.slug}`} tag={tag} />)}
        </MetaBlock>
      </Link>
      <NewMark className="webfont" featured={props.featured}>
        NEW
      </NewMark>
    </Post>
  )
}

export default Card
